import { useQuery } from '@tanstack/react-query';
import { fetchRecentTransactions, type Order } from '../services/recentTransacService';


export const useRecentTransactions = (limit = 60) => {
  return useQuery<Order[], Error>({
    queryKey: ['recentTransactions', limit],
    queryFn: () => fetchRecentTransactions(limit),
    staleTime: 1000 * 60 * 5,
  });
};